import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconCallLogProps } from './IconCallLog.types'
import * as Styled from './styles/IconCallLog.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCallLog: FC<IconCallLogProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCallLogProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconCallLogProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M21.46 17.215a.3.3 0 0 1 .017.105 3.412 3.412 0 0 1-.153.97c-.375 1.214-1.387 2.523-2.582 2.874-3.015.898-6.191-.023-9-1.434a12.118 12.118 0 0 1-5.383-5.355c-1.418-2.79-2.343-5.95-1.441-8.95C3.273 4.239 4.59 3.23 5.812 2.86l.981-.257a.318.318 0 0 1 .383.203l.773 2.265 1.184 3.301.027.086a.374.374 0 0 1-.125.426 4.34 4.34 0 0 1-1.27.664 7.656 7.656 0 0 1-1.68.328.355.355 0 0 0-.265.164.346.346 0 0 0-.043.309 12.259 12.259 0 0 0 3.02 4.968 12.37 12.37 0 0 0 5 3.008.372.372 0 0 0 .308-.043.35.35 0 0 0 .16-.265c.051-.567.165-1.13.337-1.668.152-.457.378-.883.668-1.262a.373.373 0 0 1 .43-.125l.085.027 3.317 1.18c.789.277 1.46.559 2.25.84.039.015.085.133.109.207Zm-4.987-8.711v3h3m-3-.008L20.469 7.5m-5-1v-3h-3m3 .008-3.996 3.996'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconCallLog
